module.exports = __webpack_public_path__ + "static/img/logo-lotteshopping.04abe8f.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/project/logo-lotteshopping.png
// module id = 1tmk
// module chunks = 0